import * as React from "react";
import CategoriesCard from "../../../CatrgoriesCardComponent/Component";
import "./PublicProfile.css";
import getProfile from "../../../../requests/getProfile";
import { Book } from "../../../../types/Book";
import Card from "../../../Feed/Card/Card";
import ProfileMenu from "../ProfileMenu/ProfileMenu";
import { useSelector } from "react-redux";
import { getUserState } from "../../../../store/user/selectors";
import { useParams } from "react-router-dom";
import { User } from "../../../../types/User";
import { useMediaQuery } from "react-responsive";
import { MOBILE_MAX_WIDTH } from "../../../../utils";
import MobileSlideMenu from "./MobileSlideMenu/MobileSlideMenu";
import { Helmet } from "react-helmet";
import cn from 'classnames';
import UserHistoryComponent from "../UserHistory/UserHistory";
import { UserHistoryItem } from "../../../../types/UserHistory";

const PublicProfile: React.FC = (props) => {
	const userProfile = useSelector(getUserState);
	const [books, setBooks] = React.useState<Book[]>([]);
	const params = useParams<{ id: string }>();
	const [publicProfile, setPublicProfile] = React.useState<User>(null);
	const isMobile = useMediaQuery({ maxWidth: MOBILE_MAX_WIDTH });
	const [historyItems, setHistoryItems] = React.useState<UserHistoryItem[]>([]);

	React.useEffect(() => {
		getProfile(parseInt(params.id)).then((data) => {
			setBooks([...data.library.readNow, ...data.library.alreadyRead]);

			setPublicProfile(data.user);

			setHistoryItems(data.userHistory);
		});
	}, [params.id]);

	const onMoreLoad = (lastId: number) => {
		getProfile(parseInt(params.id), lastId).then((data) => {
			setHistoryItems([...historyItems, ...data.userHistory]);
		});
	}

	const canBeEditable = React.useMemo(() => {
		return parseInt(params?.id) === userProfile?.user?.id;
	}, [params, userProfile]);

	return (
		<div className="publicProfile__wrapper">
			<div className="publicProfile-main">
				<div className="publicProfile__header">Последние действия</div>

				{!publicProfile && books.length === 0 && (
						<div className="publicProfile-cards">
							{[...new Array(7).keys()].map((item) => {
								return <Card book={{} as any} dummy={true} />;
							})}
						</div>
					)}

				{publicProfile && books.length === 0 && (
					<div className="publicProfile-cards__empty">
						{canBeEditable
							? "В вашей библиотеке пока нет книг"
							: "У пользователя пока нет книг в библиотеке"}
					</div>
				)}

				<div className="publicProfile-cards">
					<UserHistoryComponent items={historyItems} onMoreLoad={onMoreLoad} />
				</div>
			</div>

			<div className="publicProfile-right">
				<div
					className={cn("profilePage__header", {
						profilePage__header_loading: !publicProfile,
					})}
				>
					{publicProfile && (
						<Helmet>
							<title>{publicProfile.name} - Readed.me </title>
						</Helmet>
					)}

					<div className="profilePage__avatar">
						{publicProfile?.imageURL && <img src={publicProfile?.imageURL} />}

						{isMobile && canBeEditable && (
							<MobileSlideMenu className="profilePage__avatar__settings">
								<ProfileMenu />
							</MobileSlideMenu>
						)}
					</div>

					<div className="profilePage__data">
						<div className="profilePage__name">{publicProfile?.name}</div>
					</div>
				</div>

				{!isMobile && canBeEditable && <ProfileMenu />}

				{publicProfile && (
					<div>
						<div className="profilePage-categories__header">
							Популярные категории
						</div>

						<CategoriesCard userId={publicProfile.id} disable={true} />
					</div>
				)}
			</div>
		</div>
	);
};

export default PublicProfile;
